import React, { CSSProperties, ReactNode } from "react";
import useStyles from "./styles";
// import closeIcon from "../../../assets/closeModel.png";
import closeIcon from "../../../assets/closeModel.png";
import {
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert,
  Dialog,
  Breakpoint,
  DialogActions,
  Typography,
} from "@mui/material";

interface PopupProps {
  open: boolean;
  fullWidth: boolean;
  fullScreen?: boolean;
  maxWidth?: false | Breakpoint;
  children?: React.ReactNode; // Make children prop optional
  title: string;
  onHide: () => void;
  alert?: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  disableContentText?: boolean;
  popupBg?: string;
  bgHeader?: string;
  dialogStyle?: CSSProperties;
}

const Popup: React.FC<PopupProps> = ({
  open,
  fullWidth,
  fullScreen,
  maxWidth,
  children,
  title,
  onHide,
  alert,
  header,
  footer,
  disableContentText = false,
  popupBg,
  dialogStyle,
  bgHeader,
}) => {
  const classes = useStyles();

  return (
    <>
      <style>
        {`
          @media print {
            .print-border {
              border: 0 !important;
            }
          }
        `}
      </style>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        fullScreen={fullScreen}
        open={open}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: { ...dialogStyle },
        }}
      >
        <div
          className="print-border"
          style={{
            border: "2px solid #848181",
            margin: "6px",
            borderRadius: "5px",
            background: popupBg || "#EEECEF",
            ...dialogStyle,
          }}
        >
          <DialogTitle
            style={{
              background: bgHeader ?? "none",
              alignItems: "center",
              color: bgHeader ? "#fff" : "inherit",
            }}
            className={classes.popupTitle}
          >
            <>
              {/* Right-aligned icons */}
              {header || (
                <>
                  <img
                    onClick={onHide}
                    src={closeIcon}
                    className={classes.closeicons}
                    alt="close"
                  />
                </>
              )}
            </>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                // marginTop: "10px",
                textTransform: "capitalize",
              }}
            >
              {title}
            </Typography>
          </DialogTitle>
          <DialogContent
            sx={{ padding: disableContentText ? "16px" : "0px" }}
          >
            {disableContentText ? (
              children
            ) : (
              <DialogContentText className={classes.formBox}>
                {children}
              </DialogContentText>
            )}
          </DialogContent>
          {alert && <Alert severity="error">{alert}</Alert>}
          <DialogActions className={classes.modelFooter}>
            {footer}
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
};

export default Popup;
